const oddsKeyArray = ['OVER', 'UNDER', 'EVEN', 'ODD']
const oddsZodiacArray = ['RAT', 'OXEN', 'TIGER', 'RABBIT', 'DRAGON', 'SNAKE', 'HORSE', 'GOAT', 'MONKEY', 'ROOSTER', 'DOG', 'PIG']
const oddsColorArray = ['RED', 'BLUE', 'GREEN']
const oddsElement = ['METAL', 'WOOD', 'WATER', 'EARTH', 'FIRE']
const locateKeys = ['first', 'second', 'third', 'fourth', 'fifth']
const getLocateText = (i, j) => `${i}:LOCATE:${j}`

export {
  oddsKeyArray,
  oddsZodiacArray,
  oddsColorArray,
  oddsElement,
  getLocateText,
  locateKeys
}
